/**
 * Set by /shopify/auth/callback
 * @see shopify.routes.ts
 */
export const SHOPIFY_AUTH_SESSION_COOKIE = "supliful.app.shopify.confirm"

export const getShopifyAuthSessionCookieOptions = (domain: string) => {
  const cookieOptions = {
    httpOnly: false,
    secure: true,
    sameSite: "lax",
    maxAge: 600000,
    domain,
    path: "/",
  } as const

  return cookieOptions
}
